import React from 'react';

export default function AccountingInfo() {
  return (
    <section id="accounting-info">
      <p className="body-title mt-4">Painel de informações</p>
    </section>
  );
}
